module.exports = __webpack_public_path__ + "img/warning-toaster.f93509f.svg";